__turbopack_context__.v({
  "active": "FaqSection-module-scss-module__Z3-dKG__active",
  "ant-collapse-content-box": "FaqSection-module-scss-module__Z3-dKG__ant-collapse-content-box",
  "ant-collapse-header": "FaqSection-module-scss-module__Z3-dKG__ant-collapse-header",
  "app_light_theme": "FaqSection-module-scss-module__Z3-dKG__app_light_theme",
  "faqIcon": "FaqSection-module-scss-module__Z3-dKG__faqIcon",
  "faqItem": "FaqSection-module-scss-module__Z3-dKG__faqItem",
  "faqValue": "FaqSection-module-scss-module__Z3-dKG__faqValue",
  "main": "FaqSection-module-scss-module__Z3-dKG__main",
  "title": "FaqSection-module-scss-module__Z3-dKG__title",
  "value": "FaqSection-module-scss-module__Z3-dKG__value",
});
